import { hasOwn } from "../../commonFunctions/arrayFunc";
import { SMConfig } from "./DefaultConfig/SMConfig";
import { appBlockConfig } from "./DefaultConfig/appBlockConfig";
import { elementConfig } from "./DefaultConfig/elementConfig";
import { formFieldConfig, subFormFieldConfig } from "./DefaultConfig/formFieldConfig";

const getDefaultConfig = (type) => {
  const config = getConfig[type];
  const immutateCopy = createImmutableCopy(config);
  return immutateCopy;
};

const getFormFieldConfig = (type) => {
  const config = formFieldConfig[type];
  const immutateCopy = createImmutableCopy(config);
  return immutateCopy;
};
const getSubFormFieldConfig = (type) => {
  const config = subFormFieldConfig[type];
  const immutateCopy = createImmutableCopy(config);
  return immutateCopy;
};

const getConfig = {
  ...elementConfig,
  ...appBlockConfig,
  ...SMConfig
  // ...formFieldConfig //TODO: type button is a common in form and element so we neglect it
};

const modifiedObjectAsConfig = (actualObj, defaultObj) => {
  const copyActualObject = createImmutableCopy(actualObj);
  return mergeObjects(copyActualObject, defaultObj);
};

const ignoredKeys = ["id", "created_at", "modified_at", "deleted_at", "app_id", "card_design"];
function mergeObjects(actualObj, defaultObj) {
  const mergedObj = {};

  //   Merge properties from the default object
  for (const key in defaultObj) {
    if (Array.isArray(defaultObj[key])) {
      if (actualObj[key] && Array.isArray(actualObj[key])) {
        if (defaultObj[key].length === 1) {
          if (typeof defaultObj[key][0] === "object") {
            const newArray = actualObj[key].map((ele) => {
              return mergeObjects(ele, defaultObj[key][0]);
            });
            mergedObj[key] = newArray;
          }
          if (defaultObj[key][0] === "TYPE") {
            const newArray = actualObj[key].map((ele) => {
              const newDefaultConfig = getDefaultConfig(ele.type);
              return mergeObjects(ele, newDefaultConfig);
            });
            mergedObj[key] = newArray;
          }
        } else {
          mergedObj[key] = actualObj[key];
        }
      } else {
        mergedObj[key] = [];
      }
    } else if (
      typeof defaultObj[key] === "object" &&
      defaultObj[key] !== null &&
      !Array.isArray(defaultObj[key]) &&
      Object.keys(defaultObj[key]).length !== 0
    ) {
      mergedObj[key] = mergeObjects(actualObj[key] || {}, defaultObj[key]);
    } else if (!(key in actualObj)) {
      mergedObj[key] = defaultObj[key];
    } else {
      mergedObj[key] = actualObj[key];
    }
  }

  // Remove properties from the actual object that are not in the default object
  for (const key in actualObj) {
    if (ignoredKeys.includes(key)) {
      mergedObj[key] = actualObj[key];
    }
    if (hasOwn(actualObj, key) && !(key in defaultObj)) {
      delete actualObj[key];
    }
  }

  return mergedObj;
}

const createImmutableCopy = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};

export { getDefaultConfig, modifiedObjectAsConfig, getFormFieldConfig, getSubFormFieldConfig };
